<template>
  <div class="h-100 w-100">
    <nav
      type="light"
      class="navbar navbar-light sticky-top bg-light flex-md-nowrap px-0 py-2 shadow d-block d-md-none"
    >
      <!--       <a class="navbar-brand col-md-3 col-lg-2 mr-0 px-3" href="/"
        >Veins Energia</a
      > -->
      <!--   <img class="navbar-brand logo-veins mr-0 " src="/images/logo_veins.png" alt style="width: 6em"/> -->
      <button
        class="navbar-toggler position-absolute d-md-none"
        type="button"
        data-toggle="collapse"
        data-target="#sidebarMenu"
        aria-controls="sidebarMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="() => collapse()"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <ul class="navbar-nav px-3">
        <li class="nav-item text-nowrap">
          <a class="nav-link" href="/logout">
            <span v-if="state.currentUser">{{ state.currentUser }} -</span> Sair
          </a>
        </li>
      </ul>
    </nav>

    <div class="container-fluid h-100">
      <div class="row m-0 w-100 h-100">
        <nav
          id="sidebarMenu"
          class="col d-md-block bg-light sidebar"
          :class="{ collapse: state.collapsed }"
        >
          <div
            class="sidebar-sticky pt-5 pt-md-1 h-100 d-flex justify-content-between flex-column"
          >
            <ul class="nav flex-column mt-4 mt-md-1">
              <div>
                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Dashboard')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/dashboard') }"
                    @click="this.setCollapsed"
                    href="/#/dashboard"
                  >
                    <b-icon-house></b-icon-house>&nbsp;Home
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="hasPermissionToAccess(state.userData.profile, 'Users')"
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/users') }"
                    @click="this.setCollapsed"
                    href="/#/users"
                  >
                    <b-icon-people></b-icon-people>&nbsp;Usuários
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <div
                  v-if="
                    hasPermissionToAccess(
                      state.userData.profile,
                      'Installation',
                    )
                  "
                >
                  <li class="nav-item">
                    <hr class="horizontal-separator" />
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/installation') }"
                      @click="this.setCollapsed"
                      href="/#/installation"
                    >
                      <b-icon-bullseye></b-icon-bullseye>&nbsp;Instalações
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>
                </div>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Panorama')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/panorama') }"
                    @click="this.setCollapsed"
                    href="/#/panorama"
                  >
                    <b-icon-bullseye></b-icon-bullseye>&nbsp;Panorama
                    <span class="sr-only">(current)</span>
                  </a>
                </li>
                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Panorama')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/new-panorama') }"
                    @click="this.setCollapsed"
                    href="/#/new-panorama"
                  >
                    <b-icon-bullseye></b-icon-bullseye>&nbsp;Novo Panorama
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(
                      state.userData.profile,
                      'PanoramaCustom',
                    )
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/panorama-custom') }"
                    @click="this.setCollapsed"
                    href="/#/panorama-custom"
                  >
                    <b-icon-bullseye></b-icon-bullseye>&nbsp;Panorama Custom
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Billing')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/billing') }"
                    @click="this.setCollapsed"
                    href="/#/billing"
                  >
                    <b-icon-cash-stack></b-icon-cash-stack>&nbsp;Faturamento
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(
                      state.userData.profile,
                      'OverdueInvoice',
                    )
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/overdue-invoice') }"
                    @click="this.setCollapsed"
                    href="/#/overdue-invoice"
                  >
                    <b-icon-cash-stack></b-icon-cash-stack>&nbsp;Faturas
                    Atrasadas
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <div
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Coupons')
                  "
                >
                  <li class="nav-item">
                    <hr class="horizontal-separator" />
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/coupons') }"
                      @click="this.setCollapsed"
                      href="/#/coupons"
                    >
                      <b-icon-wallet2></b-icon-wallet2>&nbsp;Cupom
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>
                </div>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Commissions')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/commission') }"
                    @click="this.setCollapsed"
                    href="/#/commission"
                  >
                    <b-icon-cash-stack></b-icon-cash-stack>&nbsp;Comissões
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <div>
                  <li class="nav-item">
                    <hr class="horizontal-separator" />
                  </li>
                  <li
                    class="nav-item"
                    v-if="
                      hasPermissionToAccess(
                        state.userData.profile,
                        'LeadsExtract',
                      )
                    "
                  >
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/leads-extract') }"
                      @click="this.setCollapsed"
                      href="/#/leads-extract"
                    >
                      <b-icon-building></b-icon-building>&nbsp;Leads:extrair
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>

                  <li
                    class="nav-item"
                    v-if="
                      hasPermissionToAccess(state.userData.profile, 'Leads')
                    "
                  >
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/leads') }"
                      @click="this.setCollapsed"
                      href="/#/leads"
                    >
                      <b-icon-building></b-icon-building>&nbsp;Leads
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>
                  <li
                    class="nav-item"
                    v-if="
                      hasPermissionToAccess(
                        state.userData.profile,
                        'LeadsQualified',
                      )
                    "
                  >
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/qualified-leads') }"
                      @click="this.setCollapsed"
                      href="/#/qualified-leads"
                    >
                      <b-icon-building></b-icon-building>&nbsp;Leads
                      qualificados
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>

                  <li
                    class="nav-item"
                    v-if="
                      hasPermissionToAccess(
                        state.userData.profile,
                        'LeadsQualified',
                      )
                    "
                  >
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/leads-report') }"
                      @click="this.setCollapsed"
                      href="/#/leads-report"
                    >
                      <b-icon-building></b-icon-building>&nbsp;Relatório de
                      leads
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>
                </div>

                <div
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Investments')
                  "
                >
                  <li class="nav-item">
                    <hr class="horizontal-separator" />
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/investments') }"
                      @click="this.setCollapsed"
                      href="/#/investments"
                    >
                      <b-icon-bar-chart></b-icon-bar-chart>&nbsp;Investimentos
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>
                </div>

                <div
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'PowerPlants')
                  "
                >
                  <li class="nav-item">
                    <hr class="horizontal-separator" />
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/power-plants') }"
                      @click="this.setCollapsed"
                      href="/#/power-plants"
                    >
                      <b-icon-lightning></b-icon-lightning>&nbsp;Usinas
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>
                </div>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(
                      state.userData.profile,
                      'Cooperatives',
                    )
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/cooperatives') }"
                    @click="this.setCollapsed"
                    href="/#/cooperatives"
                  >
                    <b-icon-building></b-icon-building>&nbsp;Cooperativas
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(
                      state.userData.profile,
                      'Distributors',
                    )
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/distributors') }"
                    @click="this.setCollapsed"
                    href="/#/distributors"
                  >
                    <b-icon-lightning-fill></b-icon-lightning-fill
                    >&nbsp;Distribuidoras
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Covenant')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/covenant') }"
                    @click="this.setCollapsed"
                    href="/#/covenant"
                  >
                    <b-icon-building></b-icon-building>&nbsp;Convênios
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <div
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Loggers')
                  "
                >
                  <li class="nav-item">
                    <hr class="horizontal-separator" />
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/loggers') }"
                      @click="this.setCollapsed"
                      href="/#/loggers"
                    >
                      <b-icon-archive></b-icon-archive>&nbsp;Logs
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>
                </div>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Contracts')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/contracts') }"
                    @click="this.setCollapsed"
                    href="/#/contracts"
                  >
                    <b-icon-brush></b-icon-brush>&nbsp;Contratos
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="hasPermissionToAccess(state.userData.profile, 'Faqs')"
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/faq') }"
                    @click="this.setCollapsed"
                    href="/#/faqs"
                  >
                    <b-icon-list-check></b-icon-list-check>&nbsp;FAQ
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(
                      state.userData.profile,
                      'Notifications',
                    )
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/notification') }"
                    @click="this.setCollapsed"
                    href="/#/notifications"
                  >
                    <b-icon-bell></b-icon-bell>&nbsp;Notificações
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <div
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'AdminUsers')
                  "
                >
                  <li class="nav-item">
                    <hr class="horizontal-separator" />
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/admin-user') }"
                      @click="this.setCollapsed"
                      href="/#/admin-users"
                    >
                      <b-icon-lock></b-icon-lock>&nbsp;Administradores
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>
                </div>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Consumers')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/consumer') }"
                    @click="this.setCollapsed"
                    href="/#/consumers"
                  >
                    <b-icon-cart></b-icon-cart>&nbsp;Consumidores
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Traders')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/trader') }"
                    @click="this.setCollapsed"
                    href="/#/traders"
                  >
                    <b-icon-briefcase></b-icon-briefcase>&nbsp;Comercializadores
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <li
                  class="nav-item"
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Partners')
                  "
                >
                  <a
                    class="nav-link"
                    :class="{ active: isMenuActive('/partner') }"
                    @click="this.setCollapsed"
                    href="/#/partners"
                  >
                    <b-icon-people></b-icon-people>&nbsp;Parceiros
                    <span class="sr-only">(current)</span>
                  </a>
                </li>

                <div
                  v-if="
                    hasPermissionToAccess(state.userData.profile, 'Investors')
                  "
                >
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: isMenuActive('/investor') }"
                      @click="this.setCollapsed"
                      href="/#/investors"
                    >
                      <b-icon-cash-stack></b-icon-cash-stack>&nbsp;Investidores
                      <span class="sr-only">(current)</span>
                    </a>
                  </li>
                </div>
              </div>
            </ul>
            <div>
              <div class="nav-item">
                <hr class="horizontal-separator" />
              </div>

              <!-- Novo botão para o sistema externo -->
              <div class="nav-item text-nowrap">
                <button
                  class="nav-link btn-new-system"
                  @click="goToNewSystem"
                  title="Abrir no novo sistema"
                >
                  <b-icon-box-arrow-up-right
                    class="icon-new-system"
                  ></b-icon-box-arrow-up-right>
                  <span>Novo Sistema</span>
                </button>
              </div>

              <div class="nav-item">
                <hr class="horizontal-separator" />
              </div>

              <div class="nav-item text-nowrap bottom-user">
                <a class="nav-link" href="/logout">
                  <span v-if="state.currentUser"
                    >{{ state.currentUser }} -</span
                  >
                  Sair
                </a>
              </div>

              <div class="nav-item">
                <hr class="horizontal-separator" />
              </div>

              <img
                class="navbar-brand logo-veins mr-0 "
                src="/images/logo_veins.png"
                alt
                style="width: 6em"
              />
            </div>
          </div>
        </nav>
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from '../vue/auth';
import { hasPermissionToAccess } from '../vue/routes/permissions';

export default {
  name: 'app',
  data: function() {
    return {
      state: {
        currentUser: null,
        collapsed: true,
        userData: {},
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const session = await Auth.hasSession();
    const userData = await Auth.getSessionData();

    if (!session) {
      this.$router.push('/login');
    } else {
      this.state.currentUser = session;
      this.state.userData = userData;

      if (this.$route.path === '/') {
        this.$router.push('/dashboard');
      }
    }
  },
  methods: {
    hasPermissionToAccess,
    isMenuActive(menu) {
      return (
        this.$route.path.startsWith(menu) || this.$route.path.endsWith(menu)
      );
    },
    collapse() {
      this.state.collapsed = !this.state.collapsed;
    },
    setCollapsed() {
      this.state.collapsed = true;
    },
    goToNewSystem() {
      Auth.initiateSSO('https://veins-backoffice.vercel.app');
    },
  },
  components: {},
};
</script>

<style>
.horizontal-separator {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.bottom-user {
  position: relative;
  bottom: 0;
  margin-top: auto;
}

.btn-new-system {
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #fd8e39, #e67016);
  color: white;
  border-radius: 8px;
  padding: 10px 15px;
  margin: 5px 15px;
  border: none;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.btn-new-system:hover {
  background: linear-gradient(135deg, #e67016, #d15500);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  color: white;
}

.icon-new-system {
  font-size: 1.2em;
}
</style>
